export const hasControlErrors = control => {
  if (!control) return false;
  const isFormDirty = control.dirty;
  const formErrors = control.errors;
  if (isFormDirty && formErrors) {
    return formErrors?.['required'] ?? formErrors?.['optionNotAvailable'] ?? false;
  }
  return false;
};
export const translateOptions = (options, translateService) => {
  options.forEach(option => {
    if (option.nameKey) option.name = translateService.instant(option.nameKey);
  });
};
